/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Features_Rbac_DescriptionInputs */

const en_landing_features_rbac_description = /** @type {(inputs: Landing_Features_Rbac_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fine-grained RBAC with wildcard matching. Full admin panel for managing users, roles, and permissions.`)
};

const zh_landing_features_rbac_description = /** @type {(inputs: Landing_Features_Rbac_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`细粒度的 RBAC 权限控制，支持通配符匹配。完整的管理后台管理用户、角色和权限。`)
};

/**
* | output |
* | --- |
* | "Fine-grained RBAC with wildcard matching. Full admin panel for managing users, roles, and permissions." |
*
* @param {Landing_Features_Rbac_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_features_rbac_description = /** @type {((inputs?: Landing_Features_Rbac_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Features_Rbac_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_features_rbac_description(inputs)
	return zh_landing_features_rbac_description(inputs)
});
export { landing_features_rbac_description as "landing.features.rbac.description" }